import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const TemplateFormButton = ({
  icon,
  title,
  description,
  isSelected,
  name,
  value,
  checked,
  onChange,
  onClick = () => {},
  disableButton,
  dataTestId,
}) => {
  return (
    <label
      className={`
        flex-1 flex flex-col items-start justify-center py-3 px-4 rounded-xl border-2 
        ${
          disableButton
            ? isSelected
              ? "cursor-not-allowed"
              : "dark:bg-gray-600 cursor-not-allowed"
            : isSelected
            ? "bg-indigo-100 dark:bg-indigo-900 border-indigo-300 dark:border-indigo-600 cursor-pointer shadow-inner"
            : "bg-indigo-50 dark:bg-indigo-900/50 dark:border-indigo-900 border-indigo-50 dark:bg-gray-700 hover:bg-indigo-100 dark:hover:bg-indigo-900 hover:border-indigo-200 dark:hover:border-indigo-600 transition-all cursor-pointer"
        } font-medium
      `}
      onClick={disableButton ? undefined : onClick}
      data-testid={dataTestId}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disableButton}
        className="sr-only"
      />
      <div className="flex items-center gap-4">
        <FontAwesomeIcon
          icon={icon}
          size="3x"
          className={"text-indigo-500"}
        />
        <div className="flex flex-col">
          <span className="font-semibold">{title}</span>
          <span className="text-xs font-normal">{description}</span>
        </div>
      </div>
    </label>
  );
};

export default TemplateFormButton;
